import { render, staticRenderFns } from "./advertRight.vue?vue&type=template&id=57b2b29c&scoped=true"
import script from "./advertRight.vue?vue&type=script&lang=js"
export * from "./advertRight.vue?vue&type=script&lang=js"
import style0 from "./advertRight.vue?vue&type=style&index=0&id=57b2b29c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b2b29c",
  null
  
)

export default component.exports